import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { icons } from '@shared/static/icons';
import { useTranslation } from 'react-i18next';
import { ThemeButton } from '@shared/ui/buttons';

export default function NestedConfirmDialog({
  open,
  close,
  title,
  text,
  onSubmit,
  loading,
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="xs"
      aria-labelledby="nested-confirm-dialog-title"
      className="customDialog"
    >
      <DialogTitle
        id="nested-confirm-dialog-title"
        className="customDialog__heading"
      >
        <div className="customDialog__heading-icon">
          {icons.warning}
          <p className="title-h2m">{title}</p>
        </div>
      </DialogTitle>

      <DialogContent>
        <p>{text}</p>
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton onClick={onSubmit} startIcon="check" loading={loading}>
            {t('confirm')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}
